import React, { useEffect } from "react";
import { Box, Button, Checkbox, Divider, FormControl, CircularProgress, FormControlLabel, Grid, InputAdornment, InputLabel, Paper, TextField, Typography, Table, TableHead, TableRow, TableBody, TableCell, OutlinedInput } from "@mui/material";
import { useState, useRef, useMemo } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import InputStyle from "../../../assets/InputStyle";
import flagIcon from "../../../images/flagIcon.png";
import { Select, MenuItem } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '../../../images/upload.svg';
import AddIcon from '@mui/icons-material/Add';
import regex from "../../../utils/regex";
import NumberInput from "../../../utils/NumberInput";
import { display } from "@mui/system";
import JoditEditor from "jodit-react";
import { enqueueSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { createProfile, uploadImages } from "../../../actions/userAuth";
import { DeleteOutline } from "@mui/icons-material";

const General = ({ setSelectedTab }) => {

    const [countryCode, setCountryCode] = useState("+358");
    const [image, setImage] = React.useState('');
    const [name, setName] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [mobileNumber, setMobileNumber] = React.useState('');
    const [nationality, setNationality] = React.useState('');
    const [gender, setGender] = React.useState('');
    const [experience, setExperience] = React.useState();
    const [fatherName, setFatherNmae] = React.useState('');
    const [motherName, setMotherName] = React.useState('');
    const [dob, setDob] = React.useState('');
    const [skills, setSkills] = React.useState({});
    const [allSkills, setAllSkills] = React.useState([]);
    const [languages, setLanguages] = React.useState("");
    const [allLanguages, setAllLanguages] = React.useState([]);
    const [languageLevel, setLanguageLevel] = React.useState("");
    const [adhaarCardNumber, setAdhaarCardNumber] = React.useState('');
    const [pan, setPan] = React.useState('');
    const [passportDetails, setPassportDetails] = React.useState('');
    const [gstNumber, setGstNumber] = React.useState('');
    const [country, setCountry] = React.useState('');
    const [state, setState] = React.useState('');
    const [city, setCity] = React.useState('');
    const [pincode, setPincode] = React.useState('');
    const [address, setAddress] = React.useState('');
    const [specialities, setSpecialities] = React.useState("");
    const [bankName, setBankNAme] = React.useState('');
    const [nameOnAccount, setNameOnAccount] = React.useState('');
    const [accountNumber, setAccountNumber] = React.useState('');
    const [reAccountNumber, setReaccountNumber] = React.useState('');
    const [ifsc, setIFSC] = React.useState('');
    const [swift, setSwift] = React.useState('');
    const [accountType, setAccounType] = React.useState('');
    const [linkedin, setLinkedin] = React.useState('');
    const [portfolio, setPortfolio] = React.useState('');
    const [skillLevel, setSkillLevel] = React.useState('');
    const [adhaarFront, setAdhaarFront] = React.useState('');
    const [adhaarBack, setAdhaarBack] = React.useState('');
    const [panPhoto, setPanPhoto] = React.useState('');
    const [gstPhoto, setGstPhoto] = React.useState('');
    const [passportFront, setPassportFront] = React.useState('');
    const [passportBack, setPassportBack] = React.useState('');
    const [resume, setResume] = React.useState('');

    const [gstError, setGstError] = useState(true);
    const [emailError, setEmailError] = useState(true);
    const [adhaarError, setAdhaarError] = useState(true);
    const [panError, setPanError] = useState(true);
    const [ifscError, setIfscError] = useState(true);
    const [value, setValue] = useState("");
    const [allSpecialities, setAllSpecialities] = useState([]);
    const editor = useRef(null);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { user } = useSelector((state) => ({ ...state }));

    useEffect(() => {
        setImage(user?.avatar);
        setName(user?.name);
        setEmail(user?.email);
        setMobileNumber(user?.phone?.slice(-10));
        setCountryCode(user?.phone?.slice(0, -10));
        setAdhaarFront(user?.aadharCardPhotos?.frontSide);
        setAdhaarBack(user?.aadharCardPhotos?.rearSide);
        setPassportFront(user?.passPortPhotos?.frontSide);
        setPassportBack(user?.passPortPhotos?.rearSide);
        setPanPhoto(user?.panCardPhoto);
        setNationality(user?.nationality);
        setGender(user?.gender);
        setExperience(user?.experience);
        setFatherNmae(user?.fatherName);
        setMotherName(user?.motherName);
        setDob(user?.dateOfBirth?.split('T')[0]);
        setAllSkills(user?.skills);
        setAllLanguages(user?.languages);
        setAdhaarCardNumber(user?.aadharCardNumber);
        setPan(user?.panCardNumber);
        setPassportDetails(user?.passPortNumber);
        setGstNumber(user?.GST_Number);
        setPincode(user?.pinCode);
        setCountry(user?.country);
        setState(user?.state);
        setCity(user?.city);
        setPincode(user?.pinCode);
        setAddress(user?.address);
        setValue(user?.description);
        setLinkedin(user?.socialNetworks?.linkedIn);
        setPortfolio(user?.socialNetworks?.portFolio);
        if (user?.specialities?.length > 0) {
            setAllSpecialities(user?.specialities);
        }
        if(user?.uploadResume){
            setResume(JSON.parse(user?.uploadResume));
        }
    }, [user])

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setAllSpecialities(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleSubmit = () => {
        setLoading(true);
        console.log(
            name, email, mobileNumber, nationality, fatherName, experience, motherName, dob, allSkills.length == 0, allLanguages.length == 0, adhaarCardNumber, pan, passportDetails, country, city, value
            , image, panPhoto, adhaarFront, adhaarBack, passportFront, passportBack
        );
        if (!name || !email || !mobileNumber || !nationality || !fatherName || !experience ||
            !motherName || !dob || allSkills.length == 0 || allLanguages.length == 0 || !adhaarCardNumber || !pan || !passportDetails ||
            !country || !city || !value || !image || !panPhoto || !adhaarFront || !adhaarBack || !passportFront || !passportBack) {
            enqueueSnackbar("Please fill in all the required fields", { variant: 'warning' });
            setLoading(false);
            return;
        } else {
            let payload = {
                avatar: image,
                panCardPhoto: panPhoto,
                aadharCardPhotos: {
                    frontSide: adhaarFront,
                    rearSide: adhaarBack
                },
                passPortPhotos: {
                    frontSide: passportFront,
                    rearSide: passportBack,
                },
                uploadResume: JSON.stringify(resume),
                fullName: name,
                email,
                mobileNumber,
                nationality,
                gender,
                experience,
                fatherName,
                motherName,
                dateOfBirth: dob,
                skills: allSkills,
                languages: allLanguages,
                aadharCardNumber: adhaarCardNumber,
                passPortNumber: passportDetails,
                panCardNumber: pan,
                passportDetails,
                GST_Number: gstNumber,
                specialities: allSpecialities,
                bankDetails: {
                    bankName,
                    nameOnAccount,
                    accountNumber,
                    reAccountNumber: reAccountNumber,
                    IFSC_code: ifsc,
                    SWIFT_code: swift,
                    accountType,
                },

                country,
                state,
                city,
                pinCode: pincode,
                address,
                description: value,
                socialNetworks: {
                    linkedIn: linkedin,
                    portFolio: portfolio,

                }
            }
            let role = JSON.parse(localStorage.getItem("user"));
            dispatch(createProfile(payload, role._id, role.role, (data) => {
                console.log(data)
                enqueueSnackbar("General details added successfully", { variant: 'success' });
                setLoading(false);
                setSelectedTab(1);
            }, (err) => {
                setLoading(false);
                enqueueSnackbar("Error Occured! please try again", { variant: 'warning' });
            }, localStorage.getItem("refreshToken")))
        }
    }

    React.useEffect(() => {
        if (email) {
            const isEmailValid = regex.emailPattern.test(email)
            setEmailError(isEmailValid)
        }
    }, [email])

    React.useEffect(() => {
        if (gstNumber) {
            const isGstValid = regex.gstPattern.test(gstNumber)
            setGstError(isGstValid)
        }
    }, [gstNumber])

    React.useEffect(() => {
        if (adhaarCardNumber) {
            const isAdhaarValid = regex.adhaarPattern.test(adhaarCardNumber)
            setAdhaarError(isAdhaarValid)
        }
    }, [adhaarCardNumber])

    React.useEffect(() => {
        if (pan) {
            const isPanValid = regex.panPattern.test(pan)
            setPanError(isPanValid)
        }
    }, [pan])

    React.useEffect(() => {
        if (ifsc) {
            const isIfscError = regex.ifscPattern.test(ifsc)
            setIfscError(isIfscError)
        }
    }, [ifsc])

    const handleUploadImage = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                const img = new Image();

                img.onload = () => {
                    const width = img.width;
                    const height = img.height;
                    if (width < 136 || height < 136) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with atleast 136 height and width", { variant: 'warning' });
                    } else if (file.size / 1024 > 1024) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with less than 1MB size", { variant: 'warning' });
                    } else {
                        let formData = new FormData();
                        formData.append("file", file);
                        dispatch(uploadImages(formData, (data) => {
                            setImage(data.data.imagesKey[0]);
                        }, (err) => {
                            enqueueSnackbar("Error Occured! Please try again", { variant: 'error' });
                        }))
                    }
                };

                img.src = reader.result;
            };

            reader.readAsDataURL(file);
        }
    }

    const uploadAdhaarFront = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                const img = new Image();

                img.onload = () => {
                    const width = img.width;
                    const height = img.height;
                    if (width < 136 || height < 136) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with atleast 136 height and width", { variant: 'warning' });
                    } else if (file.size / 1024 > 1024) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with less than 1MB size", { variant: 'warning' });
                    } else {
                        let formData = new FormData();
                        formData.append("file", file);
                        dispatch(uploadImages(formData, (data) => {
                            setAdhaarFront(data.data.imagesKey[0]);
                        }, (err) => {
                            enqueueSnackbar("Error Occured! Please try again", { variant: 'error' });
                        }))
                    }
                };

                img.src = reader.result;
            };

            reader.readAsDataURL(file);
        }
    }

    const uploadAdhaarBack = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                const img = new Image();

                img.onload = () => {
                    const width = img.width;
                    const height = img.height;
                    if (width < 136 || height < 136) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with atleast 136 height and width", { variant: 'warning' });
                    } else if (file.size / 1024 > 1024) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with less than 1MB size", { variant: 'warning' });
                    } else {
                        let formData = new FormData();
                        formData.append("file", file);
                        dispatch(uploadImages(formData, (data) => {
                            setAdhaarBack(data.data.imagesKey[0]);
                        }, (err) => {
                            enqueueSnackbar("Error Occured! Please try again", { variant: 'error' });
                        }))
                    }
                };

                img.src = reader.result;
            };

            reader.readAsDataURL(file);
        }
    }

    const uploadPanPhoto = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                const img = new Image();

                img.onload = () => {
                    const width = img.width;
                    const height = img.height;
                    if (width < 136 || height < 136) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with atleast 136 height and width", { variant: 'warning' });
                    } else if (file.size / 1024 > 1024) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with less than 1MB size", { variant: 'warning' });
                    } else {
                        let formData = new FormData();
                        formData.append("file", file);
                        dispatch(uploadImages(formData, (data) => {
                            setPanPhoto(data.data.imagesKey[0]);
                        }, (err) => {
                            enqueueSnackbar("Error Occured! Please try again", { variant: 'error' });
                        }))
                    }
                };

                img.src = reader.result;
            };

            reader.readAsDataURL(file);
        }
    }

    const uploadGst = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                const img = new Image();

                img.onload = () => {
                    const width = img.width;
                    const height = img.height;
                    if (width < 136 || height < 136) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with atleast 136 height and width", { variant: 'warning' });
                    } else if (file.size / 1024 > 1024) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with less than 1MB size", { variant: 'warning' });
                    } else {
                        let formData = new FormData();
                        formData.append("file", file);
                        dispatch(uploadImages(formData, (data) => {
                            setGstPhoto(data.data.imagesKey[0]);
                        }, (err) => {
                            enqueueSnackbar("Error Occured! Please try again", { variant: 'error' });
                        }))
                    }
                };

                img.src = reader.result;
            };

            reader.readAsDataURL(file);
        }
    }

    const uploadPassportFront = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                const img = new Image();

                img.onload = () => {
                    const width = img.width;
                    const height = img.height;
                    if (width < 136 || height < 136) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with atleast 136 height and width", { variant: 'warning' });
                    } else if (file.size / 1024 > 1024) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with less than 1MB size", { variant: 'warning' });
                    } else {
                        let formData = new FormData();
                        formData.append("file", file);
                        dispatch(uploadImages(formData, (data) => {
                            setPassportFront(data.data.imagesKey[0]);
                        }, (err) => {
                            enqueueSnackbar("Error Occured! Please try again", { variant: 'error' });
                        }))
                    }
                };

                img.src = reader.result;
            };

            reader.readAsDataURL(file);
        }
    }

    const uploadPassportBack = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                const img = new Image();

                img.onload = () => {
                    const width = img.width;
                    const height = img.height;
                    if (width < 136 || height < 136) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with atleast 136 height and width", { variant: 'warning' });
                    } else if (file.size / 1024 > 1024) {
                        window.isImageValid = false;
                        enqueueSnackbar("Please upload a image with less than 1MB size", { variant: 'warning' });
                    } else {
                        let formData = new FormData();
                        formData.append("file", file);
                        dispatch(uploadImages(formData, (data) => {
                            setPassportBack(data.data.imagesKey[0]);
                        }, (err) => {
                            enqueueSnackbar("Error Occured! Please try again", { variant: 'error' });
                        }))
                    }
                };

                img.src = reader.result;
            };

            reader.readAsDataURL(file);
        }
    }

    const uploadResume = (e) => {
        const file = e.target.files[0];
        if (file) {
            let formData = new FormData();
            formData.append("file", file);
            dispatch(uploadImages(formData, (data) => {
                let payload = {
                    name: file.name,
                    image: data.data.imagesKey[0]
                }
                setResume(payload);
            }, (err) => {
                enqueueSnackbar("Error Occured! Please try again", { variant: 'error' });
            }))
        }
    }

    const handleAddAllLanguages = () => {
        if (!languages || !languageLevel) {
            enqueueSnackbar("Please select appropriate language and level before adding", { variant: 'warning' });
        } else {
            setAllLanguages(oldArr => [...oldArr, { language: languages, languageLevel: languageLevel }]);
        }
        setLanguages("");
        setLanguageLevel("");
    }

    const handleAddAllSkills = () => {
        if (!skills || !skillLevel) {
            enqueueSnackbar("Please select appropriate skills and level before adding", { variant: 'warning' });
        } else {
            setAllSkills(oldArr => [...oldArr, { skill: skills, skillLevel: skillLevel }]);
        }
        setSkills("");
        setSkillLevel("");
    }

    const handleDeleteLanguages = (index) => {
        setAllLanguages(prevArray => {
            // Create a new array excluding the item at the specified index
            const newArray = [...prevArray];
            newArray.splice(index, 1);
            return newArray;
        });
    }

    const handleDeleteSkill = (index) => {
        setAllSkills(prevArray => {
            // Create a new array excluding the item at the specified index
            const newArray = [...prevArray];
            newArray.splice(index, 1);
            return newArray;
        });
    }

    const handleRemoveSpeciality = (item) => {
        var index = allSpecialities.indexOf(item);
        if (index !== -1) {
            setAllSpecialities(prevArray => {
                // Create a new array excluding the item at the specified index
                const newArray = [...prevArray];
                newArray.splice(index, 1);
                return newArray;
            });
        }
    }

    return (
        <>
            <Box py={3}>
                <Box sx={{ backgroundColor: '#F6F8F9', px: { md: 5, xs: 0 }, py: { md: 10, xs: 2 }, borderRadius: '4px', mx: { md: 5, xs: 0 } }}>
                    <Paper sx={{ mx: { md: 4, xs: 2 }, px: { md: 5, xs: 2 }, pb: 5 }}>
                        <Box py={3} my={2}>
                            <Grid container>
                                <Grid item md={10}>
                                    <Typography variant="h5" sx={{ color: '#000', fontWeight: '600' }}>Personal Details</Typography>
                                </Grid>
                            </Grid>
                            <Divider sx={{ backgroundColor: '#e5e5e5', height: '1px', borderRadius: '2px', marginTop: '1rem' }} />
                        </Box>
                        <Grid container spacing={2}>
                            <Grid item md={2} >
                                <Box py={3} sx={{ backgroundColor: '#F8FAFF', textAlign: 'center', borderRadius: '10px', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)' }}>
                                    {
                                        image != ""
                                            ?
                                            <img
                                                src={image}
                                                style={{ width: '100%', height: '100px', objectFit: 'contain' }}
                                            />
                                            :
                                            <PersonIcon sx={{ color: '#fff', fontSize: '6rem', color: '#2544EE' }} />

                                    }
                                    <Button
                                        variant="contained"
                                        component="label"
                                        my={3}
                                        sx={{ width: '90%', height: '20%', fontSize: "8px", fontWeight: 'bold', backgroundColor: '#2544EE' }}
                                    >
                                        Upload Image
                                        <input
                                            onChange={handleUploadImage}
                                            type="file"
                                            accept=".jpg,.png"
                                            hidden
                                            required
                                        />
                                    </Button>
                                </Box>

                            </Grid>

                            <Grid item md={10}>
                                <p>Profile Image :- Max file size is 1MB, Minimum dimension: 136 x 136 And Suitable files are .jpg & .png</p>
                            </Grid>
                        </Grid>

                        <Grid container my={2}>
                            <Grid item xs={12} md={4}>
                                <InputStyle name="Full Name*" topSpace={true}>
                                    <input type="text" placeholder="Enter Your Name"
                                        disabled
                                        value={name}
                                        onChange={(e) => setName(e.target.value)} />
                                </InputStyle>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <InputStyle name="Email Address*" topSpace={true}>
                                    <input type="text" placeholder="Enter Your Email"
                                        value={email}
                                        disabled
                                        onChange={(e) => setEmail(e.target.value)} />
                                </InputStyle>
                                {!emailError ? <p style={{ color: 'red', fontWeight: 'bold' }}>Invalid Input</p> : ""}

                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Mobile Number*
                                </Typography>
                                <NumberInput isdisabled={true} countryCode={countryCode} setCountryCode={setCountryCode} mobileNumber={mobileNumber} setMobileNumber={setMobileNumber} />
                            </Grid>
                        </Grid>

                        <Grid container my={2}>
                            <Grid item xs={12} md={4}>
                                <InputStyle name="Nationality*" topSpace={true}>
                                    <input type="text" placeholder="Enter Your Nationality"
                                        value={nationality}
                                        onChange={(e) => setNationality(e.target.value)} />
                                </InputStyle>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Gender
                                </Typography>
                                <Box >

                                    <select className="input-box" name="cars" id="cars"
                                        value={gender}
                                        onChange={(e) => setGender(e.target.value)}>
                                        <option value="">Select</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </Box>

                            </Grid>
                            <Grid item xs={12} md={4}>
                                <InputStyle name="Experience(In Years)*" topSpace={true}>
                                    <input type="number" placeholder="Enter Your Experience"
                                        value={experience}
                                        onChange={(e) => setExperience(e.target.value)} />
                                </InputStyle>
                            </Grid>
                        </Grid>

                        <Grid container my={2}>
                            <Grid item xs={12} md={4}>
                                <InputStyle name="Father Name*" topSpace={true}>
                                    <input type="text" placeholder="Enter Your Nationality"
                                        value={fatherName}
                                        onChange={(e) => setFatherNmae(e.target.value)} />
                                </InputStyle>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <InputStyle name="Mother Name*" topSpace={true}>
                                    <input type="text" placeholder="Enter Your Email"
                                        value={motherName}
                                        onChange={(e) => setMotherName(e.target.value)} />
                                </InputStyle>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <InputStyle name="Date Of Birth*" topSpace={true}>
                                    <input type="date" placeholder="Enter Your Date Of BIrth"
                                        value={dob}
                                        onChange={(e) => setDob(e.target.value)} />
                                </InputStyle>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Skills*
                                </Typography>
                                <Box className="profile-skills-box mb-3">
                                    <Grid container>
                                        <Grid item xs={12} md={5}>
                                            <select className="input-box" name="cars" id="cars"
                                                value={skills}
                                                onChange={(e) => setSkills(e.target.value)}>
                                                <option value="">Skills</option>
                                                <option value="Option 1">Option 1</option>
                                                <option value="Option 2">Option 2</option>
                                                <option value="Option 3">Option 3</option>
                                            </select>
                                        </Grid>
                                        <Grid item xs={12} md={5}>
                                            <select className="input-box" name="cars" id="cars"
                                                value={skillLevel}
                                                onChange={(e) => setSkillLevel(e.target.value)}>
                                                <option value="">Level</option>
                                                <option value="Begineer">Begineer</option>
                                                <option value="Experienced">Experienced</option>
                                            </select>
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <Button variant="contained" style={{ width: '50px' }} onClick={handleAddAllSkills}>
                                                <AddIcon />
                                            </Button>
                                        </Grid>
                                        {
                                            allSkills && allSkills.length > 0
                                                ?
                                                <>
                                                    <Table sx={{ height: '10px' }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>
                                                                    Skill
                                                                </TableCell>
                                                                <TableCell>
                                                                    Skill Level
                                                                </TableCell>
                                                                <TableCell></TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {
                                                                allSkills.map((item, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell>
                                                                            {item.skill}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {item.skillLevel}
                                                                        </TableCell>
                                                                        <TableCell><DeleteOutline sx={{ cursor: 'pointer' }} onClick={() => handleDeleteSkill(index)} /></TableCell>
                                                                    </TableRow>
                                                                ))
                                                            }
                                                        </TableBody>
                                                    </Table>
                                                </>
                                                :
                                                ""
                                        }
                                    </Grid>
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Language*
                                </Typography>
                                <Box className="profile-skills-box mb-3">
                                    <Grid container>
                                        <Grid item xs={12} md={5}>
                                            <select className="input-box" name="cars" id="cars"
                                                value={languages}
                                                onChange={(e) => setLanguages(e.target.value)}>
                                                <option value="">Language</option>
                                                <option value="Hindi">Hindi</option>
                                                <option value="English">English</option>
                                            </select>
                                        </Grid>
                                        <Grid item xs={12} md={5}>
                                            <select value={languageLevel} className="input-box" name="cars" id="cars" onChange={(e) => setLanguageLevel(e.target.value)}>
                                                <option value="">Level</option>
                                                <option value="Begineer">Begineer</option>
                                                <option value="Experienced">Experienced</option>
                                            </select>
                                        </Grid>
                                        <Grid item md={2}>
                                            <Button variant="contained" style={{ width: '50px' }} onClick={handleAddAllLanguages}>
                                                <AddIcon />
                                            </Button>
                                        </Grid>
                                        {
                                            allLanguages && allLanguages.length > 0
                                                ?
                                                <>
                                                    <Table sx={{ height: '10px' }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>
                                                                    Language
                                                                </TableCell>
                                                                <TableCell>
                                                                    Language Level
                                                                </TableCell>
                                                                <TableCell></TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {
                                                                allLanguages.map((item, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell>
                                                                            {item.language}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {item.languageLevel}
                                                                        </TableCell>
                                                                        <TableCell><DeleteOutline sx={{ cursor: 'pointer' }} onClick={() => handleDeleteLanguages(index)} /></TableCell>
                                                                    </TableRow>
                                                                ))
                                                            }
                                                        </TableBody>
                                                    </Table>
                                                </>
                                                :
                                                ""
                                        }
                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} my={2}>
                            <Grid item xs={12} md={6} >
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Adhaar Card Number*
                                </Typography>

                                <Box className="profile-skills-box mb-3">
                                    <Grid container>
                                        <Grid item md={12}>
                                            <input
                                                className="input-box"
                                                style={{ width: '100%', paddingLeft: '0.5rem' }}
                                                placeholder="Adhaar Number"
                                                require
                                                value={adhaarCardNumber}
                                                onChange={(e) => setAdhaarCardNumber(e.target.value)}
                                            />
                                            {!adhaarError ? <p style={{ color: "red", fontWeight: 'bold' }}>Invalid Input</p> : ""}

                                            <Grid container sx={{ textAlign: 'center', py: 2 }}>
                                                <Grid item xs={12} md={5} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <InputStyle name=" " topSpace={true} >

                                                        <Button
                                                            variant="outlined"
                                                            component="label"
                                                            sx={{
                                                                width: '100%',
                                                                height: '100%',
                                                                fontSize: '14px',
                                                                border: 'none',
                                                                color: '#2544EE',
                                                                display: 'flex',
                                                                flexDirection: 'column'
                                                            }}
                                                        >
                                                            {
                                                                adhaarFront != ""
                                                                    ?
                                                                    <img
                                                                        src={adhaarFront}
                                                                        style={{ width: '96px', height: '96px' }}
                                                                    />
                                                                    :
                                                                    <>
                                                                        <img src={CloudUploadIcon} sx={{ mx: 5 }} />
                                                                        <div className="text2Mid" style={{ color: '#000', opacity: '0.5' }}>Upload front side photo</div>
                                                                    </>


                                                            }


                                                            <input onChange={uploadAdhaarFront}
                                                                type="file"
                                                                accept=".jpg,.png"
                                                                hidden
                                                                required />
                                                        </Button>
                                                    </InputStyle>
                                                </Grid>

                                                <Grid item md={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Divider orientation="vertical" flexItem sx={{ width: '0.1rem', backgroundColor: '#000', borderRadius: '1px' }} />
                                                </Grid>

                                                <Grid item xs={12} md={5} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <InputStyle name=" " topSpace={true} >
                                                        <Button
                                                            variant="outlined"
                                                            component="label"
                                                            sx={{
                                                                width: '100%',
                                                                height: '100%',
                                                                fontSize: '14px',
                                                                border: 'none',
                                                                color: '#2544EE',
                                                                display: 'flex',
                                                                flexDirection: 'column'
                                                            }}
                                                        >
                                                            {
                                                                adhaarBack != ""
                                                                    ?
                                                                    <img
                                                                        src={adhaarBack}
                                                                        style={{ width: '96px', height: '96px' }}
                                                                    />
                                                                    :
                                                                    <>
                                                                        <img src={CloudUploadIcon} sx={{ mx: 5 }} />
                                                                        <div className="text2Mid" style={{ color: '#000', opacity: '0.5' }}>Upload back side photo</div>
                                                                    </>


                                                            }


                                                            <input onChange={uploadAdhaarBack}
                                                                type="file"
                                                                accept=".jpg,.png"
                                                                hidden
                                                                required />
                                                        </Button>
                                                    </InputStyle>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={6} >
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Pan Card Number*
                                </Typography>

                                <Box className="profile-skills-box mb-3">

                                    <Grid container>
                                        <Grid item md={12}>

                                            <input
                                                value={pan}
                                                onChange={(e) => setPan(e.target.value)}
                                                className="input-box"
                                                style={{ width: '100%', paddingLeft: "0.5rem,", marginBottom: '1rem' }}
                                                placeholder="Enter Pan Card Number"
                                                require
                                            />
                                            {!panError ? <p style={{ color: "red", fontWeight: 'bold' }}>Invalid Input</p> : ""}

                                            <Grid container sx={{ textAlign: 'center', py: 2 }}>
                                                <Grid item md={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <InputStyle name=" " topSpace={true} >
                                                        <Button
                                                            variant="outlined"
                                                            component="label"
                                                            sx={{
                                                                width: '100%',
                                                                height: '100%',
                                                                fontSize: '14px',
                                                                border: 'none',
                                                                color: '#2544EE',
                                                                display: 'flex',
                                                                flexDirection: 'column'
                                                            }}
                                                        >
                                                            {
                                                                panPhoto != ""
                                                                    ?
                                                                    <img
                                                                        src={panPhoto}
                                                                        style={{ width: '96px', height: '96px' }}
                                                                    />
                                                                    :
                                                                    <>
                                                                        <img src={CloudUploadIcon} sx={{ mx: 5 }} />
                                                                        <div className="text2Mid" style={{ color: '#000', opacity: '0.5' }}>Upload picture</div>
                                                                    </>
                                                            }
                                                            <input onChange={uploadPanPhoto}
                                                                type="file"
                                                                accept=".jpg,.png"
                                                                hidden
                                                                required />
                                                        </Button>
                                                    </InputStyle>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>


                        </Grid>

                        <Grid container spacing={2} my={2}>
                            <Grid item xs={12} md={6} >
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Social Security Number / Passport Details ( If Situated out of India) *
                                </Typography>

                                <Box className="profile-skills-box mb-3">

                                    <Grid container>
                                        <Grid item md={12}>

                                            <input
                                                className="input-box"
                                                style={{ width: '100%', paddingLeft: "0.5rem" }}
                                                placeholder="Enter Your Social Security Number / Passport Number  "
                                                require
                                                value={passportDetails}
                                                onChange={(e) => setPassportDetails(e.target.value)}
                                            />

                                            <Grid container sx={{ textAlign: 'center', py: 2 }}>
                                                <Grid item xs={12} md={5} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <InputStyle name=" " topSpace={true} >

                                                        <Button
                                                            variant="outlined"
                                                            component="label"
                                                            sx={{
                                                                width: '100%',
                                                                height: '100%',
                                                                fontSize: '14px',
                                                                border: 'none',
                                                                color: '#2544EE',
                                                                display: 'flex',
                                                                flexDirection: 'column'
                                                            }}
                                                        >
                                                            {
                                                                passportFront != ""
                                                                    ?
                                                                    <img
                                                                        src={passportFront}
                                                                        style={{ width: '96px', height: '96px' }}
                                                                    />
                                                                    :
                                                                    <>
                                                                        <img src={CloudUploadIcon} sx={{ mx: 5 }} />
                                                                        <div className="text2Mid" style={{ color: '#000', opacity: '0.5' }}>Upload front page photo</div>
                                                                    </>


                                                            }
                                                            <input onChange={uploadPassportFront}
                                                                type="file"
                                                                accept=".jpg,.png"
                                                                hidden
                                                                required />
                                                        </Button>
                                                    </InputStyle>
                                                </Grid>

                                                <Grid item md={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <Divider orientation="vertical" flexItem sx={{ width: '0.1rem', backgroundColor: '#000', borderRadius: '1px' }} />
                                                </Grid>

                                                <Grid item md={5} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <InputStyle name=" " topSpace={true} >

                                                        <Button
                                                            variant="outlined"
                                                            component="label"
                                                            sx={{
                                                                width: '100%',
                                                                height: '100%',
                                                                fontSize: '14px',
                                                                border: 'none',
                                                                color: '#2544EE',
                                                                display: 'flex',
                                                                flexDirection: 'column'
                                                            }}
                                                        >
                                                            {
                                                                passportBack != ""
                                                                    ?
                                                                    <img
                                                                        src={passportBack}
                                                                        style={{ width: '96px', height: '96px' }}
                                                                    />
                                                                    :
                                                                    <>
                                                                        <img src={CloudUploadIcon} sx={{ mx: 5 }} />
                                                                        <div className="text2Mid" style={{ color: '#000', opacity: '0.5' }}>Upload back page photo</div>
                                                                    </>
                                                            }


                                                            <input onChange={uploadPassportBack}
                                                                type="file"
                                                                accept=".jpg,.png"
                                                                hidden
                                                                required />
                                                        </Button>
                                                    </InputStyle>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={6} >
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    GST Number
                                </Typography>

                                <Box className="profile-skills-box mb-3">

                                    <Grid container>
                                        <Grid item md={12}>
                                            <input
                                                className="input-box"
                                                style={{ width: '100%', paddingLeft: "0.5rem", marginBottom: '1rem' }}
                                                placeholder="Enter Your GST Number"
                                                required
                                                value={gstNumber}
                                                onChange={(e) => setGstNumber(e.target.value)}
                                            />
                                            {!gstError ? <p style={{ color: "red", fontWeight: 'bold' }}>Invalid Input</p> : ""}


                                            <Grid container sx={{ textAlign: 'center', py: 2 }}>
                                                <Grid item md={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <InputStyle name=" " topSpace={true} >

                                                        <Button
                                                            variant="outlined"
                                                            component="label"
                                                            sx={{
                                                                width: '100%',
                                                                height: '100%',
                                                                fontSize: '14px',
                                                                border: 'none',
                                                                color: '#2544EE',
                                                                display: 'flex',
                                                                flexDirection: 'column'
                                                            }}
                                                        >
                                                            {
                                                                gstPhoto != ""
                                                                    ?
                                                                    <img
                                                                        src={gstPhoto}
                                                                        style={{ width: '96px', height: '96px' }}
                                                                    />
                                                                    :
                                                                    <>
                                                                        <img src={CloudUploadIcon} sx={{ mx: 5 }} />
                                                                        <div className="text2Mid" style={{ color: '#000', opacity: '0.5' }}>Upload picture</div>
                                                                    </>


                                                            }


                                                            <input onChange={uploadGst}
                                                                type="file"
                                                                accept=".jpg,.png"
                                                                hidden
                                                                required />
                                                        </Button>
                                                    </InputStyle>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>


                        </Grid>

                        <Grid container my={5}>
                            <Grid item xs={12} md={4}>
                                <InputStyle name="Country*" topSpace={true}>
                                    <input type="text" placeholder="Enter Your country"
                                        value={country}
                                        onChange={(e) => setCountry(e.target.value)} />
                                </InputStyle>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <InputStyle name="State*" topSpace={true}>
                                    <input type="text" placeholder="Enter Your country"
                                        value={state}
                                        onChange={(e) => setState(e.target.value)} />
                                </InputStyle>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <InputStyle name="City Name*  " topSpace={true}>
                                    <input type="text" placeholder="Enter Mobile city"
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)} />
                                </InputStyle>
                            </Grid>
                        </Grid>

                        <Grid container my={5}>
                            <Grid item xs={12} md={4}>
                                <InputStyle name="Pincode" topSpace={true}>
                                    <input type="text" placeholder="Enter Your pincode"
                                        value={pincode}
                                        onChange={(e) => setPincode(e.target.value)} />
                                </InputStyle>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Address
                                </Typography>
                                <Box >

                                    <input
                                        className="profile-skills-box mb-3"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        placeholder="Enter your full address"
                                        require
                                    />
                                </Box>
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item xs={12}>
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Bio*
                                </Typography>
                                <JoditEditor
                                    ref={editor}
                                    onChange={(newContent) => setValue(newContent)}
                                    value={value}
                                />
                            </Grid>
                        </Grid>

                        <Button
                            className="text2Mid"
                            sx={{
                                mx: '5',
                                marginTop: '1rem',
                                borderRadius: '2rem',
                                border: '1px solid #2544EE',
                                color: '#2544EE',
                                px: 5,
                                '&:hover': {
                                    backgroundColor: '#FFF',
                                    color: '#2544EE',
                                },
                            }}
                            variant="outlined"
                            component="label"
                        >
                            Upload Resume
                            <input onChange={uploadResume}
                                type="file"
                                hidden
                                accept=".pdf"
                                required />
                        </Button>
                        {!resume
                            ?
                            ""
                            :
                            <>
                                <p style={{ margin: '0.5rem 0rem' }}>{resume.name}
                                    <button style={{ border: 'none', backgroundColor: '#fff', }} onClick={() => (setResume(""))} >
                                        <CloseIcon sx={{ color: '#2544EE' }} />
                                    </button></p>

                            </>

                        }
                        <Typography variant="caption" sx={{ display: 'block', mt: 2 }}>DOC, DOCX, PDF (5MB)</Typography>
                    </Paper>

                    <Paper sx={{ mx: { md: 4, xs: 1 }, my: 3 }}>
                        <Box px={{ md: 4, xs: 1 }} py={3}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Specialities*</Typography>
                            <Divider sx={{ backgroundColor: '#e5e5e5', height: '1px', borderRadius: '2px', marginTop: '1rem' }} />

                            <Box>
                                {/* <select className="profile-skills-box" name="cars" id="cars"
                                    value={specialities}
                                    onChange={(e) => setSpecialities(e.target.value)}>
                                    <option value="volvo">Volvo</option>
                                    <option value="saab">Saab</option>
                                    <option value="mercedes">Mercedes</option>
                                    <option value="audi">Audi</option>
                                </select> */}
                                <FormControl sx={{ m: { md: 1, xs: 0 }, width: '100%' }}>
                                    <InputLabel id="demo-multiple-name-label">Specialities</InputLabel>
                                    <Select
                                        multiple
                                        value={allSpecialities}
                                        onChange={handleChange}
                                        input={<OutlinedInput label="Name" />}
                                    >
                                        <MenuItem
                                            value="specialities1"
                                        >
                                            Specialities 1
                                        </MenuItem>
                                        <MenuItem
                                            value="specialities2"
                                        >
                                            Specialities 2
                                        </MenuItem>
                                        <MenuItem
                                            value="specialities3"
                                        >
                                            Specialities 3
                                        </MenuItem>
                                        <MenuItem
                                            value="specialities4"
                                        >
                                            Specialities 4
                                        </MenuItem>
                                    </Select>
                                </FormControl>

                                <Box className='text2Bold' px={1} my={3} sx={{ width: 'fit-content', display: 'flex', borderRadius: '5px' }}>
                                    {
                                        allSpecialities && allSpecialities.length > 0
                                            ?
                                            allSpecialities.map((item, index) => (
                                                <Box
                                                    key={index}
                                                    className="text2Bold"
                                                    px={1}
                                                    sx={{
                                                        backgroundColor: '#D2D2D2',
                                                        width: 'max-content',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between', // Added to horizontally align items
                                                        "& p": {
                                                            margin: 0, // Added to remove default margin of <p> tag
                                                        },
                                                        borderRadius: '5px',
                                                        marginLeft: '10px',
                                                        marginRight: '10px'
                                                    }}
                                                >

                                                    <p style={{ marginRight: '1rem' }}>{item}</p>
                                                    <Button sx={{ color: 'black', }} onClick={() => handleRemoveSpeciality(item)}> {/* Set icon color to black */}
                                                        <CloseIcon sx={{ fontSize: '1rem' }} />
                                                    </Button>
                                                </Box>

                                            ))
                                            :
                                            ""
                                    }
                                </Box>
                            </Box>
                        </Box>
                    </Paper>

                    <Paper sx={{ mx: { md: 4, xs: 1 }, my: 3 }}>
                        <Box px={{ md: 5, xs: 1 }} py={3}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Bank Account Detail</Typography>
                            <Divider sx={{ backgroundColor: '#e5e5e5', height: '1px', borderRadius: '2px', marginTop: '1rem' }} />
                        </Box>

                        <Grid container sx={{ mx: { md: 4, xs: 1 } }}>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Bank Name
                                </Typography>
                                <Box >

                                    <input
                                        style={{ paddingLeft: '0.5rem' }}
                                        className="input-box mb-3"
                                        value={bankName}
                                        onChange={(e) => setBankNAme(e.target.value)}
                                        placeholder="Enter your bank name"
                                        require
                                    />
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputStyle name="Name on account" topSpace={true}>
                                    <input type="text" placeholder="Enter Your Name on Account"
                                        value={nameOnAccount}
                                        onChange={(e) => setNameOnAccount(e.target.value)} />
                                </InputStyle>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InputStyle name="Account Number" topSpace={true}>
                                    <input type="text" placeholder="Enter Your account number"
                                        value={accountNumber}
                                        onChange={(e) => setAccountNumber(e.target.value)} />
                                </InputStyle>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InputStyle name="Re-account Number" topSpace={true}>
                                    <input type="text" placeholder="Re-enter Your Account Number" onChange={(e) => setReaccountNumber(e.target.value)}
                                    />
                                </InputStyle>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    IFSC Code
                                </Typography>
                                <Box>

                                    <input
                                        style={{ paddingLeft: '0.5rem' }}
                                        value={ifsc}
                                        onChange={(e) => setIFSC(e.target.value)}
                                        placeholder="Enter your bank IFSC Code"
                                        required
                                        className="input-box mb-3"
                                    />
                                    {!ifscError ? <p style={{ color: "red", fontWeight: 'bold' }}>Invalid Input</p> : ""}

                                </Box>

                            </Grid>

                            <Grid item xs={12} md={6}>
                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    SWIFT Code
                                </Typography>
                                <Box className="input-box mb-3">

                                    <input
                                        value={swift}
                                        onChange={(e) => setSwift(e.target.value)}
                                        placeholder="Enter your swift code"
                                        require
                                    />

                                </Box>
                            </Grid>

                            <Grid item md={12}>

                                <Typography
                                    component="label"
                                    sx={{
                                        fontWeight: 500,
                                        fontFamily: "Inter",
                                        fontSize: 12,
                                    }}
                                >
                                    Account Type
                                </Typography>
                                <Box className="input-box mb-3" sx={{ width: '95%' }}>

                                    <select className="profile-skills-box" name="cars" id="cars"
                                        value={accountType}
                                        onChange={(e) => setAccounType(e.target.value)}>
                                        <option value="">Select</option>
                                        <option value="Current Account">Current Account</option>
                                        <option value="saab">Savings Account</option>
                                        <option value="mercedes">Joint Account</option>
                                    </select>
                                </Box>
                            </Grid>

                        </Grid>
                    </Paper>

                    <Paper sx={{ mx: { md: 4, xs: 1 }, my: 3 }}>


                        <Box px={{ md: 5, xs: 1 }} py={3}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', float: 'left' }}>Social Network</Typography>
                            {/* <Button mx={5} sx={{
                                mx: '5',
                                backgroundColor: '#2544EE',
                                borderRadius: '5px',
                                mx: 5,
                                px: 5,
                                float: 'right',
                                '&:hover': {
                                    backgroundColor: '#FFF',
                                    color: '#2544EE',
                                },
                            }}
                                variant="contained">
                                <AddIcon /> Add
                            </Button> */}

                            <Divider sx={{ backgroundColor: '#e5e5e5', height: '1px', borderRadius: '2px', marginTop: '1rem' }} />

                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <Typography
                                        component="label"
                                        sx={{
                                            fontWeight: 500,
                                            fontFamily: "Inter",
                                            fontSize: 12,
                                        }}
                                    >
                                        Linkedin
                                    </Typography>
                                    <Box >

                                        <input
                                            className="profile-skills-box mb-3"
                                            value={linkedin}
                                            onChange={(e) => setLinkedin(e.target.value)}
                                            placeholder="Enter your profile url"
                                            require
                                        />
                                    </Box>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Typography
                                        component="label"
                                        sx={{
                                            fontWeight: 500,
                                            fontFamily: "Inter",
                                            fontSize: 12,
                                        }}
                                    >
                                        Portfolio
                                    </Typography>
                                    <Box >

                                        <input
                                            className="profile-skills-box mb-3"
                                            value={portfolio}
                                            onChange={(e) => setPortfolio(e.target.value)}
                                            placeholder="Enter your portfolio url"
                                            require
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>


                    </Paper>

                    <Button mx={5} sx={{
                        mx: '5',
                        backgroundColor: '#2544EE',
                        borderRadius: '2rem',
                        mx: 5,
                        px: 5,
                        '&:hover': {
                            backgroundColor: '#FFF',
                            color: '#2544EE',
                        },
                    }}
                        disabled={loading}
                        onClick={handleSubmit}
                        variant="contained">
                        {
                            loading
                                ?
                                <CircularProgress size={24} />
                                :
                                "Create"
                        }
                    </Button>
                </Box>

            </Box >
        </>
    );
}

export default General;